import React from "react";
import { Link } from "react-router-dom";
import { Terminal, Github, Twitter, Linkedin, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative mt-32 border-t border-white/5 bg-deep-black"
    >
      <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-6 md:grid-cols-2 lg:grid-cols-4 lg:px-8">
        <div>
          <Link to="/" className="flex items-center gap-2 font-display text-xl font-bold">
            <span className="grid h-9 w-9 place-items-center rounded-lg border border-neon-green/40 bg-neon-green/10 text-neon-green shadow-neon-sm">
              <Terminal size={18} />
            </span>
            <span className="text-white">GITSI<span className="text-neon-green">.</span></span>
          </Link>
          <p className="mt-4 text-sm leading-relaxed text-white/60">
            India's future-ready AI &amp; Technology institute. Practical learning,
            industry-grade training, and verified certifications.
          </p>
          <div className="mt-5 flex items-center gap-3">
            <a href="#" aria-label="Github" className="grid h-9 w-9 place-items-center rounded-lg border border-white/10 text-white/70 hover:text-neon-green hover:border-neon-green/40 transition">
              <Github size={16} />
            </a>
            <a href="#" aria-label="Twitter" className="grid h-9 w-9 place-items-center rounded-lg border border-white/10 text-white/70 hover:text-neon-green hover:border-neon-green/40 transition">
              <Twitter size={16} />
            </a>
            <a href="#" aria-label="Linkedin" className="grid h-9 w-9 place-items-center rounded-lg border border-white/10 text-white/70 hover:text-neon-green hover:border-neon-green/40 transition">
              <Linkedin size={16} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-widest text-neon-green">Quick Links</h4>
          <ul className="mt-4 space-y-2 text-sm text-white/70">
            <li><Link to="/" className="hover:text-neon-green">Home</Link></li>
            <li><a href="/#about" className="hover:text-neon-green">About</a></li>
            <li><a href="/#courses" className="hover:text-neon-green">Courses</a></li>
            <li><Link to="/student-verification" className="hover:text-neon-green">Verify Marksheet</Link></li>
            <li><Link to="/admin/login" className="hover:text-neon-green">Login Panel</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-widest text-neon-green">Top Courses</h4>
          <ul className="mt-4 space-y-2 text-sm text-white/70">
            <li>Artificial Intelligence</li>
            <li>Full Stack Development</li>
            <li>Data Science</li>
            <li>Cyber Security</li>
            <li>Digital Marketing</li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-widest text-neon-green">Contact</h4>
          <ul className="mt-4 space-y-3 text-sm text-white/70">
            <li className="flex items-start gap-2"><Mail size={14} className="mt-1 text-neon-green" /> contact@gitsi.in</li>
            <li className="flex items-start gap-2"><Phone size={14} className="mt-1 text-neon-green" /> +91 98XXX XXXXX</li>
            <li className="flex items-start gap-2"><MapPin size={14} className="mt-1 text-neon-green" /> Delhi, India</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 sm:flex-row sm:px-6 lg:px-8">
          <p className="text-xs text-white/40">© {new Date().getFullYear()} GITSI Institute. All rights reserved.</p>
          <p className="font-mono text-xs text-neon-green/70">// build.gitsi.future</p>
        </div>
      </div>
    </footer>
  );
}
